import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {

  blogId: any;
  blogData: any = {};
  baseUrl = 'https://thesmilesstore.in/';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.blogId = this.route.snapshot.paramMap.get('id');
    this.loadBlogDetails();
  }

  loadBlogDetails(): void {
   
    const payload = { id: this.blogId };

    this.http.post<any>(
      this.baseUrl + 'get_blog_data/',
      payload
    ).subscribe({
      next: (res) => {
        if (res.status === 1) {
          this.blogData = res.data;

          // Fix image path
          if (this.blogData.image) {
            this.blogData.image = this.baseUrl + 'media/' + this.blogData.image;
          } else {
            this.blogData.image = 'assets/img/blog/blog1.jpg';
          }
        }
      },
      error: (err) => console.error(err)
    });
  }
}